import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { AiSettingsPage } from './AiSettingsPage'

export const routes: RouteObject[] = [{ path: '/settings/ai', element: <AiSettingsPage /> }]

export const nav: NavItem[] = [
  { path: '/settings/ai', label: 'ИИ', icon: 'ai', mobile: null, order: 50, parent: '/settings' },
]
